import classnames from 'clsx';
import { useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { testId } from 'ui-components/services/testid-service';

import { useSortedTranslatedCountries } from '../../../../hooks/use-sorted-translated-countries';
import { messages as countryNameMessages } from '../../../country-names.messages';
import internationalMessages from '../../../../pages/settings/international/messages';
import { SellerSettingsOptions } from '../../../../enums/seller-settings/seller-settings-options';
import { messages } from '../messages';
import commonStyle from '../common-style.module.less';

type CountryDropdownProps = {
  onChange: (countryCode: string) => void;
  selectedCountryCode?: string;
  pickerClassName?: string;
};

type TranslatedCountry = {
  code: string;
  label: string;
};

export const CountryDropdown = ({ onChange, selectedCountryCode = '', pickerClassName = '' }: CountryDropdownProps) => {
  const intl = useIntl();
  const countries = useSortedTranslatedCountries() as TranslatedCountry[];

  const dropdownTextMessage =
    selectedCountryCode === SellerSettingsOptions.empty.value
      ? internationalMessages.blankCountryOption
      : countryNameMessages[selectedCountryCode as keyof typeof countryNameMessages] || messages.countryOfOriginDefault;

  return (
    <DropdownMenu
      {...testId('customs-widget-country-dropdown')}
      className={commonStyle['standard-dropdown']}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      value={selectedCountryCode}
      variant='form'
    >
      <DropdownMenuToggler className={classnames(commonStyle['standard-dropdown'], pickerClassName)}>
        {intl.formatMessage(dropdownTextMessage)}
      </DropdownMenuToggler>
      <DropdownMenuItem
        key={SellerSettingsOptions.empty.value}
        onClick={() => onChange(SellerSettingsOptions.empty.value)}
        selected={selectedCountryCode === SellerSettingsOptions.empty.value}
      >
        {intl.formatMessage(internationalMessages.blankCountryOption)}
      </DropdownMenuItem>
      {countries.map(({ code, label }) => (
        <DropdownMenuItem key={code} onClick={() => onChange(code)} selected={selectedCountryCode === code}>
          {label}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
